import { isAudioMessage } from './backpressure';

/**
 * WS-1 (HITL-1411): take guest audio off the Redux/render path.
 *
 * The guest microphone stream (`data.source_name === 'ORDERBOARD'`) is the
 * high-volume audio the agent listens to — thousands of frames per order. It
 * used to be dispatched into Redux every 100ms flush and decoded inside the
 * `messageReceived` reducer, driving per-frame reducer work and a render storm
 * that (with the unbounded flush loop) starved the main thread and crashed the
 * renderer.
 *
 * The socket middleware now plays guest audio straight from the flush via the
 * `audioPlayer` singleton and never forwards audio to Redux. Non-guest audio
 * (e.g. `RESTAURANTSTAFF`) was never played anyway — the old reducer bailed on
 * any non-`ORDERBOARD` source — so it is simply dropped rather than dispatched.
 */
export const GUEST_AUDIO_SOURCE = 'ORDERBOARD';

export const isGuestAudioFrame = (message: any): boolean =>
  isAudioMessage(message) && message?.data?.source_name === GUEST_AUDIO_SOURCE;
